/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  ConfirmEcoModulationImportConfirmMutationRequest,
  ConfirmEcoModulationImportConfirmMutationResponse,
  ConfirmEcoModulationImport,
} from "../types/ConfirmEcoModulationImport.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const confirmEcoModulationImportConfirmMutationKey = () =>
  [{ url: "/v1/eco-modulations/confirm-import" }] as const

export type ConfirmEcoModulationImportConfirmMutationKey = ReturnType<
  typeof confirmEcoModulationImportConfirmMutationKey
>

/**
 * {@link /v1/eco-modulations/confirm-import}
 */
export async function confirmEcoModulationImport(
  data: ConfirmEcoModulationImportConfirmMutationRequest,
  config: Partial<
    RequestConfig<ConfirmEcoModulationImportConfirmMutationRequest>
  > & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    ConfirmEcoModulationImportConfirmMutationResponse,
    ResponseErrorConfig<Error>,
    ConfirmEcoModulationImportConfirmMutationRequest
  >({
    method: "POST",
    url: `/v1/eco-modulations/confirm-import`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function confirmEcoModulationImportConfirmMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<ConfirmEcoModulationImportConfirmMutationRequest>
  > & { client?: Client } = {}
) {
  const mutationKey = confirmEcoModulationImportConfirmMutationKey()
  return mutationOptions<
    ResponseConfig<ConfirmEcoModulationImportConfirmMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: ConfirmEcoModulationImportConfirmMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return confirmEcoModulationImport(data, config)
    },
  })
}

/**
 * {@link /v1/eco-modulations/confirm-import}
 */
export function useConfirmEcoModulationImport<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<ConfirmEcoModulationImportConfirmMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: ConfirmEcoModulationImportConfirmMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<
      RequestConfig<ConfirmEcoModulationImportConfirmMutationRequest>
    > & { client?: Client }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ??
    confirmEcoModulationImportConfirmMutationKey()

  const baseOptions = confirmEcoModulationImportConfirmMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<ConfirmEcoModulationImportConfirmMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: ConfirmEcoModulationImportConfirmMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<ConfirmEcoModulationImportConfirmMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: ConfirmEcoModulationImportConfirmMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<ConfirmEcoModulationImportConfirmMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: ConfirmEcoModulationImportConfirmMutationRequest },
    TContext
  >
}
